import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

export default function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  const cols = [
    {
      title: t.footer.product,
      links: [
        { l: t.footer.links.features, h: "#features" },
        { l: t.footer.links.pricing, h: "#pricing" },
        { l: t.footer.links.faq, h: "#faq" },
      ],
    },
    {
      title: t.footer.company,
      links: [
        { l: t.footer.links.about, h: "#" },
        { l: t.footer.links.contact, h: "mailto:hello@guardmind.app" },
        { l: t.footer.links.blog, h: "#" },
      ],
    },
    {
      title: t.footer.legal,
      links: [
        { l: t.footer.links.privacy, h: "#" },
        { l: t.footer.links.terms, h: "#" },
      ],
    },
  ];

  return (
    <footer data-testid="site-footer" className="border-t border-line pt-16 pb-10">
      <div className="container-px mx-auto max-w-7xl">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          <div className="col-span-2">
            <div className="flex items-center gap-2.5">
              <span
                className="grid h-8 w-8 place-items-center rounded-md hairline"
                style={{ background: "rgba(0,255,136,0.06)" }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M5 7l7-3 7 3v6c0 4-3 7-7 8-4-1-7-4-7-8V7Z" stroke="#00FF88" strokeWidth="1.6"/>
                  <path d="M9 12l2 2 4-4" stroke="#00FF88" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              <span className="font-display font-bold text-ink text-[15px]">GuardMind</span>
            </div>
            <p className="font-display text-ink text-2xl font-semibold mt-5 max-w-xs leading-tight">
              {t.footer.tagline}
            </p>
            <p className="text-ink/40 text-xs mt-3 max-w-xs">{t.footer.built}</p>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <p className="label-tag">{c.title}</p>
              <ul className="mt-4 space-y-3">
                {c.links.map((lk) => (
                  <li key={lk.l}>
                    <a href={lk.h} className="text-ink/70 hover:neon-text text-[14px] transition-colors">
                      {lk.l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-6 border-t flex flex-col md:flex-row md:items-center md:justify-between gap-3"
             style={{ borderColor: "rgba(245,247,250,0.08)" }}>
          <p className="mono-num text-[11px] text-ink/40">
            © {year} GUARDMIND // {t.footer.copyright.toUpperCase()}
          </p>
          <p className="mono-num text-[11px] text-ink/40">
            v0.1.0 // BETA · ALL SYSTEMS NOMINAL
          </p>
        </div>
      </div>
    </footer>
  );
}
